import { formatQueryRes, useGetHistoricQuotaQuery } from '@monorepo/shared';
import { t } from 'i18next';
import { Divider, Popover, Stack, Whisper } from 'rsuite';
import MenuIcon from '@rsuite/icons/Menu';
import { useEffect, useState } from 'react';

interface IHistoricProps {
  instance: Record<string, any>;
  account: Record<string, any>;
  region: Record<string, any>;
}
export const InstanceHistoric = ({
  instance,
  account,
  region
}: IHistoricProps) => {
  const [hasInstance, setHasInstance] = useState<boolean>(false);
  useEffect(() => {
    if (account?.has_instance || account?.instid) {
      setHasInstance(true);
    } else {
      setHasInstance(false);
    }
  }, [account]);

  const { data, isSuccess } = useGetHistoricQuotaQuery(
    formatQueryRes({
      account,
      instance,
      region
    }),
    { skip: !region?.url || !hasInstance }
  );
  const speaker = (
    <Popover
      title=""
      style={{
        border: '1px solid #28384B',
        background: '#001320'
      }}
    >
      <>
        <div>
          <span>{t('faz.organization.resource.historyTitle')}</span>
        </div>
        <Divider style={{ margin: '4px 0', color: '#28384B' }} />
        <div>
          {data?.quota_used_history?.length ? (
            data.quota_used_history.map(
              (item: Record<string, string>, key: number) => (
                <Stack key={key}>
                  <div style={{ width: '100px' }}>{item?.date}</div>
                  <div>
                    <b style={{ fontSize: '14px', padding: '0 4px' }}>
                      {Number(item?.used).toFixed(2) || 0}
                    </b>
                    <span>{'GB'}</span>
                  </div>
                </Stack>
              )
            )
          ) : (
            <div>{t('faz.organization.resource.historyNotAvailable')}</div>
          )}
        </div>
      </>
    </Popover>
  );
  return (
    <>
      <Whisper
        placement="right"
        trigger="hover"
        controlId="quota-usage-history"
        speaker={speaker}
        enterable
      >
        <span>
          <MenuIcon />
        </span>
      </Whisper>
    </>
  );
};
